export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '国产传媒平台的核心优势是什么？',
    answer: '国产传媒平台拥有三大核心优势：第一，深度本土化内容生态，覆盖影视、资讯、娱乐、科技、文化、商业六大领域；第二，权威内容审核体系，确保每篇内容经过专业编辑团队审核；第三，全渠道精准分发能力，覆盖网站、APP、社交媒体等多终端，日触达用户超过5000万。',
  },
  {
    question: '如何成为国产传媒的入驻创作者？',
    answer: '成为国产传媒的入驻创作者非常简单。您可以通过官网"创作者入驻"页面提交申请，填写基本信息并上传代表作。我们的审核团队会在3个工作日内完成审核。通过审核后，您将获得专属创作者后台，可以发布内容、查看数据、参与平台活动。',
  },
  {
    question: '国产传媒的内容审核标准是什么？',
    answer: '国产传媒坚持"真实、专业、正能量"的内容理念。所有发布内容需符合国家法律法规，坚持正确舆论导向，杜绝虚假信息、低俗内容和标题党。我们建立了三级审核机制：AI初审过滤违规内容，专业编辑复审保证内容质量，主编终审把控整体导向。',
  },
  {
    question: '企业在国产传媒投放广告有哪些合作方式？',
    answer: '国产传媒为企业提供多元化的广告合作方案，包括品牌专区、信息流广告、内容定制、KOL合作等。我们支持CPM（千次展示付费）、CPC（点击付费）、CPA（效果付费）等多种结算方式。具体合作方案可根据品牌需求和预算定制，欢迎联系我们的商务团队获取详细方案。',
  },
  {
    question: '国产传媒支持哪些内容分发渠道？',
    answer: '国产传媒拥有全渠道内容分发能力，包括自有的官方网站和移动APP，以及合作的第三方平台矩阵（涵盖微信公众号、微博、抖音、快手、B站、今日头条、百度百家等30余个主流平台）。通过智能分发系统，可以实现内容的"一次创作，多平台同步"，最大化内容的传播效果。',
  },
  {
    question: '如何获取国产传媒的内容数据报告？',
    answer: '入驻创作者和合作企业可以在后台实时查看内容数据报告，包括阅读量、互动量、用户画像、传播路径等多维度数据。我们还提供月度、季度和年度内容分析报告，帮助创作者和企业优化内容策略。如需深度定制数据报告，请联系我们的数据服务团队。',
  },
];